"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _Content = require("@quixeltools/quixel-ui-library/dist/components/common/blog/Content");

var _Content2 = _interopRequireDefault(_Content);

var _PageTitleWithBackground = require("@quixeltools/quixel-ui-library/dist/components/common/website/PageTitleWithBackground");

var _PageTitleWithBackground2 = _interopRequireDefault(_PageTitleWithBackground);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _SearchBar = require("@quixeltools/quixel-ui-library/dist/components/megascans/library/SearchBar");

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _components = require("components");

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _news = require("redux/modules/news");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var perPageItems = 9;
// const cf = path => `https://d3uwib8iif8w1p.cloudfront.net/megascans/${path}`;
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var container = function container(flag) {
  return (0, _glamor.css)({
    display: "flex",
    flexWrap: "wrap",
    textAlign: "center",
    justifyContent: flag ? "center" : "space-around",
    marginBottom: (0, _css.unitRem)(3),
    maxWidth: "1905",
    margin: "auto"
  }, (0, _polyfluid.polyfluid)({
    fontSize: {
      small: [1],
      medium: [2, 3]
    }
  }));
};

var searchbar = (0, _glamor.css)({
  width: "470px",
  minWidth: "470px",
  margin: "auto",
  marginBottom: "4rem",
  marginTop: "3.5rem"
}, (0, _css.maxWidth)(_css.breakpoints.small)({
  width: "90%",
  maxWidth: "unset",
  minWidth: "90%",
  padding: 25
}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  // maxWidth:'1200px',
  marginTop: "6rem"
}), (0, _polyfluid.polyfluid)({
  width: {
    large: [19, 40]
  }
}));

var sectionInnerHeader = (0, _glamor.css)({
  maxWidth: "75%",
  paddingLeft: 0,
  paddingRight: 0
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  maxWidth: "95%"
}));

var cont = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    small: [-2],
    medium: [-5, -8.875],
    large: [-12, -13.5]
  }
}));

var Blog = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        params = _ref.params;

    var numberPattern = /\d+/g;
    var page = params.index;
    return dispatch((0, _news.loadNews)(isNaN(page) ? 1 : page, perPageItems));
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    news: state.news,
    loading: state.news.loading,
    loaded: state.news.loaded
  };
}, { loadNews: _news.loadNews, searchArticles: _news.searchArticles }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(Blog, _React$Component);

  function Blog(props) {
    (0, _classCallCheck3.default)(this, Blog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Blog.__proto__ || (0, _getPrototypeOf2.default)(Blog)).call(this, props));

    _this.renderContent = _this.renderContent.bind(_this);
    _this.renderHeader = _this.renderHeader.bind(_this);
    _this.searchArticles = _this.searchArticles.bind(_this);
    _this.removeTag = _this.removeTag.bind(_this);
    _this.state = {
      tag: []
    };
    return _this;
  }

  (0, _createClass3.default)(Blog, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.loaded == false && nextProps.loaded == true || this.props.news.searchWord != nextProps.searchWord) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "removeTag",
    value: function removeTag(e) {
      this.setState({
        tag: []
      });
    }
  }, {
    key: "searchArticles",
    value: function searchArticles(e) {
      if (e.length > 0) {
        this.props.searchArticles(e);
      }
      this.setState({
        tag: [e]
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var props = {
        bg: "",
        title: "THE QUIXEL BLOG",
        subTitle: "Discover the latest from Quixel",
        artist: ""
      };
      return _react2.default.createElement(
        "div",
        {
          className: (0, _glamor.css)({
            backgroundColor: "#121212"
          })
        },
        _react2.default.createElement(_PageTitleWithBackground2.default, (0, _extends3.default)({
          childElement: _react2.default.createElement(
            "div",
            { className: searchbar },
            _react2.default.createElement(_SearchBar2.default, {
              className: (0, _glamor.css)({ borderRadius: "20px" }),
              blog: true,
              tags: this.state.tag,
              onTagAdd: this.searchArticles,
              onTagRemove: this.removeTag,
              onTagPop: this.removeTag
            })
          ),
          newApp: true
        }, props))
      );
    }
  }, {
    key: "renderContent",
    value: function renderContent(props) {
      return _react2.default.createElement(
        "div",
        { id: "1", className: (0, _glamor.css)(cont) },
        _react2.default.createElement(_Section2.default, {
          className: (0, _glamor.css)({ paddingBottom: "3.75rem!important" }),
          innerClassName: sectionInnerHeader,
          content: _react2.default.createElement(_Content2.default, {
            news: this.state.tag.length > 0 ? props.news.search : props.news.blog,
            loaded: props.loaded,
            count: 9,
            isHome: true
          })
        }),
        this.state.tag.length > 0 ? null : _react2.default.createElement(
          "section",
          { className: container(false) },
          props.news.length < perPageItems ? null : _react2.default.createElement(_Button2.default, {
            className: (0, _glamor.css)({ marginBottom: "4.125rem", float: "left" }),
            mode: "secondary",
            label: "<< OLD POSTS",
            to: "/blog/" + (parseInt(props.params.index) == null || typeof props.params.index == "undefined" ? 1 + 1 : parseInt(props.params.index) + 1)
          }),
          parseInt(props.params.index) == null || parseInt(props.params.index) == 1 || typeof props.params.index == "undefined" ? null : _react2.default.createElement(_Button2.default, {
            className: (0, _glamor.css)({ marginBottom: "4.125rem", float: "right" }),
            mode: "secondary",
            label: "NEW POSTS >>",
            to: "/blog/" + (parseInt(props.params.index) - 1)
          })
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Blog - Discover news and helpful resources",
          documentImage: cloudfrontThumbs("page-thumb-blog.jpg"),
          documentDescription: "Discover the latest from Quixel as we interview artists, provide tutorials and feature our amazing community here."
        },
        _react2.default.createElement(
          "div",
          null,
          this.renderHeader(),
          this.renderContent(this.props)
        )
      );
    }
  }]);
  return Blog;
}(_react2.default.Component)) || _class) || _class);
exports.default = Blog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Blog/Blog.jsx
// module id = 2966
// module chunks = 0